<template>
  <div class="batch-card-additional-information-icon">
    <div
      :id="'batch-card-additional-information-' + index"
      class="batch-card-additional-information-icon__regular"
    >
      <svg-loader
        :src="'/static/images/icon-' + additionalState + '.svg'"
        :class="additionalColor"
      />

      <md-tooltip
        md-delay="100"
        md-direction="bottom"
      >
        {{ additionalName }}
      </md-tooltip>
    </div>
  </div>
</template>

<script>
import strings from '@/strings'

export default {
  name: 'BatchCardAdditionalInformationIcon',
  props: {
    index: {
      type: Number,
      default: 0
    },
    type: {
      type: String
    }
  },
  computed: {
    additionalInformation() {
      return strings.additionalInformationStatus.find((status) => status.type === this.type)
    },
    additionalState() {
      return this.additionalInformation?.state
    },
    additionalName() {
      return this.additionalInformation?.name
    },
    additionalColor() {
      return this.additionalInformation?.color
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-card-additional-information-icon {
  flex: 20%;

  &__regular {
    width: 30px;
    height: 30px;
    position: relative;
    float: right;

    .md-icon {
      border-radius: 10%;
      padding: 4px;
      width: 100%;
      height: 100%;
    }
  }
}
</style>
